export default __webpack_public_path__ + "static/media/without-text.fda8b176.png";